import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import BusinessList from "../Business/BusinessList";
import { useSearchParams } from "react-router-dom";
import gql from "graphql-tag";
import { useQuery } from "@apollo/client";

const OperationsToolbar = styled("div")`
  display: flex;
  padding: 1rem 2rem 2rem 2rem;
  flex-wrap: wrap;
  gap: .5rem;
  ${(props) => props.theme.bp.below.lg} {
    padding: 1rem;
  }
  span {
    cursor: pointer;
    background: ${(props) => props.theme.colors.primary};
    padding: 10px 15px;
    border-radius: 50px;
    font-size: 12px;
    z-index: 4;
    position: relative;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #fff;
    border: 1px solid;
    transition: 0.3s ease-in-out;
    font-weight: 600;

    &.Fastigheter {
      background: ${(props) => props.theme.colors.properties};
      border-color: ${(props) => props.theme.colors.properties};
      color: ${(props) => props.theme.colors.properties};
    }
    &.Handel,
    &.Köpcenter {
      background: ${(props) => props.theme.colors.retail};
      border-color: ${(props) => props.theme.colors.retail};
      color: ${(props) => props.theme.colors.retail};
    }
    &.Investeringar {
      background: ${(props) => props.theme.colors.investments};
      border-color: ${(props) => props.theme.colors.investments};
      color: ${(props) => props.theme.colors.investments};
    }
    &.active {
      background: transparent;
      color: ${(props) => props.theme.colors.properties};
      border-color: ${(props) => props.theme.colors.properties};
    }
    &.inActive {
      color: #fff;
    }
  }
`;

const FilterButton = (props) => {
  const isActive = props.filters.includes(props.name) ? " active" : " inActive";

  return (
    <span
      className={props.name + isActive}
      onClick={() => props.applyFilters(props.name)}
    >
      {props.name} ({props.freePage ? props.free : props.total})
    </span>
  );
};

const Operations = ({ template, page }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState([]);

  useEffect(() => {
    const urlFilters = searchParams.get("filters");
    setFilters(urlFilters ? urlFilters.split(",") : []);
  }, [searchParams]);

  const applyFilters = (category) => {
    const newFilters = filters.includes(category)
      ? filters.filter((f) => f !== category)
      : [...filters, category];
    
    if (newFilters.length > 0) {
      setSearchParams({ filters: newFilters.join(",") });
    } else {
      setSearchParams({});
    }
  };

  const { loading: citiesLoading, error: citiesError, data: citiesData } = useQuery(city_query);

  const freePage = template === "FREE";

  return (
    <React.Fragment>
      <OperationsToolbar>
        {citiesLoading && <span>Loading filters...</span>}
        {citiesError && <span>Error loading filters</span>}
        {citiesData &&
          citiesData.cities.map((city, index) => {
            if (freePage && city.free === 0) {
              return null;
            }
            return (
              <FilterButton
                key={index}
                filters={filters}
                applyFilters={applyFilters}
                {...city}
                freePage={freePage}
              />
            );
          })}
      </OperationsToolbar>
      <BusinessList filters={filters} page={page} template={template} />
    </React.Fragment>
  );
};

const city_query = gql`
  query cityQuery {
    cities {
      name
      free
      total
    }
  }
`;

export default Operations;
